<template>
  <div>
    <el-dialog title="请选择" :visible.sync="dialogVisible" width="68%">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="来访单位" align="left">
          <template slot-scope="scope">
            <label v-if="scope.row.reservationType===0" class="label greenlabel">预</label>
            <label v-else class="label">临</label>
            {{scope.row.visitorCompanyName}}
          </template>
        </el-table-column>
        <el-table-column label="来访人" width="70">
          <template slot-scope="scope">
            <slot>{{scope.row.visitorUserName}}</slot>
          </template>
        </el-table-column>
        <el-table-column prop="targetUserName" label="受访人" width="70"></el-table-column>
        <el-table-column prop="targetDepartmentName" label="部门" width="100"></el-table-column>
        <el-table-column prop="state" label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="primary" @click.stop="select(scope.row)" size="mini" plain>选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { getToDayReservationList } from "@/api/api";
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: []
    };
  },
  methods: {
    oper(name, cardId, rid) {
      var _this = this;
      var user=JSON.parse(window.localStorage.user);
      getToDayReservationList({
        params: { userName: name, idCardNumber: cardId,companyId:user.companyId }
      }).then(res => {
        if (res.data.success) {
          var list = res.data.data;
          if (list.length === 0) {
            _this.$message.error("【姓名:"+name+",身份证:"+cardId+"】没有预约登记信息！");
          } else if (list.length === 1) {
            _this.dialogVisible = false;
            _this.$emit("backFun", list[0].id, list[0].visitorUserId);  
          } else {
            if (rid === "" || rid === undefined) {
              _this.tableData = list;
              _this.dialogVisible = true;
            } else {
              var isHave = false;
              var visitorUserId = "";
              list.forEach(element => {
                if (element.id === rid) {
                  isHave = true;
                  visitorUserId = element.visitorUserId;
                }
              });
              if (isHave === true) {
                _this.$emit("backFun", rid, visitorUserId);
              } else {
                this.$confirm("当前打开的预约单无该预约人员，是否另打开该人员预约单?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                })
                  .then(() => {
                       _this.tableData = list;
                       _this.dialogVisible = true;
                  })
                  .catch(() => {});
              }
            }
          }
        }
      });
    },
    select(row) {
      this.dialogVisible = false;
      this.$emit("backFun", row.id, row.visitorUserId);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/fksys/selectTable.vue